import { ArrowUpRight, BookOpen, Images, Sparkles } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="xv-seccion" aria-label={seccion.titulo}>
      <div className="xv-seccion-interior">
        <EncabezadoSeccion p="xv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="xv-titulo-enlaces" />
        <Reveal>
          <div className="xv-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="xv-boton"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`xv-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "xv-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "xv-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="xv-seccion" aria-label={seccion.titulo}>
      <div className="xv-seccion-interior">
        <EncabezadoSeccion p="xv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="xv-titulo-accesos" />
        <Reveal>
          <div className="xv-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="xv-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={1.5} />
                <span>
                  <span className="xv-acceso-titulo">{item.datos.titulo}</span>
                  <span className="xv-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { protagonista, evento, legal } = datos;

  return (
    <>
      <Marquee
        p="xv"
        textos={[protagonista.nombre, protagonista.fraseIntroductoria, evento.fechaCorta, evento.ciudad]}
      />
      <section className="xv-seccion xv-cierre" data-testid="xv-cierre">
        <div className="xv-seccion-interior">
          <Reveal>
            <Sparkles className="xv-cierre-destello" strokeWidth={1.5} aria-hidden="true" />
            <p className="xv-cierre-mensaje">{protagonista.mensajeCierre}</p>
            <p className="xv-cierre-nombre">{protagonista.nombre}</p>
            <div className="xv-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="xv-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="xv-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
